<template>
  <DrawerV2 v-model="visible" size="90%" title="跟进详情">
    <div class="detail-drawer-content">
      <Detail v-if="visible" :detail-query="detailQuery" is-drawer></Detail>
    </div>
  </DrawerV2>
</template>

<script setup>
import DrawerV2 from '@/components/drawer-mobile/drawer-v2.vue'
import Detail from '@/pages/details/visit-path-detail/index.vue'

defineOptions({ name: 'AiDetailDrawer' })

defineProps({
  detailQuery: {
    type: Object,
    default: () => ({})
  }
})

const visible = defineModel({ type: Boolean, default: false })
</script>

<style lang="scss" scoped>
.detail-drawer-content {
  height: 100%;
  overflow-y: auto;
  background: #f3f3f3;
}
</style>
